// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import CommentEditController from "./comment_edit_controller"
application.register("comment-edit", CommentEditController)

import ComposerAssistantController from "./composer_assistant_controller"
application.register("composer-assistant", ComposerAssistantController)

import ComposerController from "./composer_controller"
application.register("composer", ComposerController)

import ComposerModalController from "./composer_modal_controller"
application.register("composer-modal", ComposerModalController)

import ComposerModeController from "./composer_mode_controller"
application.register("composer-mode", ComposerModeController)

import DiscoverController from "./discover_controller"
application.register("discover", DiscoverController)

import DmComposerController from "./dm_composer_controller"
application.register("dm-composer", DmComposerController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import EmojiPickerController from "./emoji_picker_controller"
application.register("emoji-picker", EmojiPickerController)

import EmojiReactionsController from "./emoji_reactions_controller"
application.register("emoji-reactions", EmojiReactionsController)

import ExpandTextController from "./expand_text_controller"
application.register("expand-text", ExpandTextController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import GoldenCarouselController from "./golden_carousel_controller"
application.register("golden-carousel", GoldenCarouselController)

import HistoryArenaController from "./history_arena_controller"
application.register("history-arena", HistoryArenaController)

import InfiniteScrollController from "./infinite_scroll_controller"
application.register("infinite-scroll", InfiniteScrollController)

import InviteLinkController from "./invite_link_controller"
application.register("invite-link", InviteLinkController)

import LightboxController from "./lightbox_controller"
application.register("lightbox", LightboxController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import AccentPickerController from "./accent_picker_controller"
application.register("accent-picker", AccentPickerController)

import AutoDismissController from "./auto_dismiss_controller"
application.register("auto-dismiss", AutoDismissController)

import BibleDrawerController from "./bible_drawer_controller"
application.register("bible-drawer", BibleDrawerController)

import ChessPuzzleController from "./chess_puzzle_controller"
application.register("chess-puzzle", ChessPuzzleController)

import MentionsController from "./mentions_controller"
application.register("mentions", MentionsController)

import MessageEditController from "./message_edit_controller"
application.register("message-edit", MessageEditController)

import MessageMenuController from "./message_menu_controller"
application.register("message-menu", MessageMenuController)

import ProfileHeroController from "./profile_hero_controller"
application.register("profile-hero", ProfileHeroController)

import FeedTabsController from "./feed_tabs_controller"
application.register("feed-tabs", FeedTabsController)

import ScrollTopController from "./scroll_top_controller"
application.register("scroll-top", ScrollTopController)

import ScrollProgressController from "./scroll_progress_controller"
application.register("scroll-progress", ScrollProgressController)

import ChatScrollController from "./chat_scroll_controller"
application.register("chat-scroll", ChatScrollController)

import NewPostsPillController from "./new_posts_pill_controller"
application.register("new-posts-pill", NewPostsPillController)

import NotificationSoundController from "./notification_sound_controller"
application.register("notification-sound", NotificationSoundController)

import OnboardingController from "./onboarding_controller"
application.register("onboarding", OnboardingController)

import NotificationsModalController from "./notifications_modal_controller"
application.register("notifications-modal", NotificationsModalController)

import NotificationsPageController from "./notifications_page_controller"
application.register("notifications-page", NotificationsPageController)

import PostFormController from "./post_form_controller"
application.register("post-form", PostFormController)

import QuizController from "./quiz_controller"
application.register("quiz", QuizController)

import PwaController from "./pwa_controller"
application.register("pwa", PwaController)

import PristineFieldController from "./pristine_field_controller"
application.register("pristine-field", PristineFieldController)

import RainController from "./rain_controller"
application.register("rain", RainController)

import RainToggleController from "./rain_toggle_controller"
application.register("rain-toggle", RainToggleController)

import ReactionsController from "./reactions_controller"
application.register("reactions", ReactionsController)

import ReactorsModalController from "./reactors_modal_controller"
application.register("reactors-modal", ReactorsModalController)

import ReplyToggleController from "./reply_toggle_controller"
import CmThreadController from "./cm_thread_controller"
import ScrollActiveController from "./scroll_active_controller"
import ScheduleFieldController from "./schedule_field_controller"
application.register("reply-toggle", ReplyToggleController)
application.register("cm-thread", CmThreadController)
application.register("scroll-active", ScrollActiveController)
application.register("schedule-field", ScheduleFieldController)

import RepostMenuController from "./repost_menu_controller"
application.register("repost-menu", RepostMenuController)

import ScriptureController from "./scripture_controller"
application.register("scripture", ScriptureController)

import ShareController from "./share_controller"
application.register("share", ShareController)

import ThemeController from "./theme_controller"
application.register("theme", ThemeController)

import ThreadToggleController from "./thread_toggle_controller"
application.register("thread-toggle", ThreadToggleController)

import TocController from "./toc_controller"
application.register("toc", TocController)

import VoicePlayerController from "./voice_player_controller"
application.register("voice-player", VoicePlayerController)

import VoiceRecorderController from "./voice_recorder_controller"
application.register("voice-recorder", VoiceRecorderController)

import TypingController from "./typing_controller"
application.register("typing", TypingController)

import ListFilterController from "./list_filter_controller"
application.register("list-filter", ListFilterController)

import LocalTimeController from "./local_time_controller"
application.register("local-time", LocalTimeController)

import PasswordFieldController from "./password_field_controller"
application.register("password-field", PasswordFieldController)

import WhatsNewController from "./whats_new_controller"
application.register("whats-new", WhatsNewController)
